import { Body1, Button, ButtonGroup, Grid, GridItem, Modal } from '@sainsburys-tech/fable'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { IModal } from '../../types/IModal'

const SelectFavoriteModal = (props: IModal) => {
  const [openModal, setIsModalOpen] = useState(false)

  useEffect(() => {
    setIsModalOpen(props.isOpen)
  }, [props.isOpen])

  return (
    <React.Fragment>
      <Modal
        isOpen={openModal}
        onClose={() => props.onClose()}
        header={{
          label: props.modalTitle,
        }}
      >
        <div>
          {props.modalBody && (
            <div data-testid='modalBody'>
              <Body1 style={{ marginBottom: '16px' }}>{props.modalBody}</Body1>
            </div>
          )}
          <Grid cols={12}>
            <GridItem colSpan={{ xs: 12, sm: 6 }}>
              <Link
                tabIndex={-1}
                to={props.linkpath ? props.linkpath : '/error'}
                className='c-link-black'
              >
                <Button
                  testid='on-yes-button'
                  isFullWidth autoFocus={false}
                  onClick={() =>
                    props.onYes === undefined ? null : props.onYes()
                  }
                >
                  {props.modalYes}
                </Button>
              </Link>
            </GridItem>
            <GridItem colSpan={{ xs: 12, sm: 6 }}>
              <Link
                tabIndex={-1}
                to={props.linkpath ? props.linkpath : '/error'}
                className='c-link-black'
              >
                <Button
                  data-testid='on-no-button'
                  isFullWidth autoFocus={false}
                  onClick={() =>
                    props.onNo === undefined ? null : props.onNo()
                  }
                  variant='secondary'
                  style={{
                    backgroundColor:
                      'var(--fable-color-background-secondary-default)',
                  }}
                >
                  {props.modalNo}
                </Button>
              </Link>
            </GridItem>
          </Grid>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default SelectFavoriteModal
